import { InputProps, MenuItem, OutlinedInputProps, TextField, TextFieldProps } from "@mui/material";
import { ChangeEvent, ComponentPropsWithoutRef } from "react";
import { Controller, FieldValues, useFormContext } from "react-hook-form";

import styles from "./FormSelect.module.scss";
type IFormInputProps = {
    name: string;
    label?: string;
    options: { label: string; value: string | number; disabled?: boolean }[];
    otherInputProps?: TextFieldProps;
    InputProps?: Partial<OutlinedInputProps | InputProps>;
} & ComponentPropsWithoutRef<typeof TextField>;

export const MSelect = (inputProps: IFormInputProps) => {
    const { options, onChange, required = true, value, variant, ...otherInputProps } = inputProps;
    return (
        <TextField
            onChange={onChange}
            value={value ?? ""}
            fullWidth
            required={required}
            variant={variant}
            {...(variant === "filled" && {
                InputProps: { disableUnderline: true },
            })}
            select
            className={styles.customSelect}
            SelectProps={{
                MenuProps: {
                    PaperProps: {
                        style: {
                            maxHeight: "268px",
                        },
                    },
                },
            }}
            {...otherInputProps}
        >
            {options.map((option) => (
                <MenuItem key={option.label} value={option.value} disabled={option?.disabled}>
                    {option.label}
                </MenuItem>
            ))}
        </TextField>
    );
};

const FormSelect = (inputProps: IFormInputProps) => {
    const { name, options, defaultValue, error, onChange, ...otherInputProps } = inputProps;

    const { control } = useFormContext<FieldValues>();

    const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        onChange && onChange(e);
    };
    return (
        <Controller
            name={name}
            control={control}
            // 讓 RHF 使用外部 defaultValues；僅在呼叫端明確提供時才採用
            defaultValue={defaultValue ?? ""}
            render={({ field: { onChange, value }, fieldState: { error }, formState }) => {
                return (
                    <MSelect
                        variant='filled'
                        name={name}
                        value={value ?? ""}
                        onChange={(e) => {
                            // multiple: string[] / 單選: string|number
                            const nextValue = (e.target as HTMLInputElement).value as unknown;
                            onChange(nextValue);
                            handleChange(e);
                        }}
                        options={options}
                        error={!!error}
                        helperText={error ? error.message : null}
                        {...otherInputProps}
                    />
                );
            }}
        />
    );
};
export default FormSelect;
